/* External */
import { memo, useMemo } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import Skeleton from '@dtvgo/skeleton';

/* Utils */
import { Channel } from '../../storage/models';
import { getImage } from '../../utils/imageUtils';

/* Styles */
import './ChannelLaneSkeleton.scss';

const CHANNEL_IMAGE_WIDTH = 80;

function ChannelLaneSkeleton({
  channel,
  className,
  withoutFilter,
  emptyChannelsMessage,
}) {
  const { images } = channel || {};

  const imageUrl = useMemo(
    () => getImage(images, CHANNEL_IMAGE_WIDTH),
    [images],
  );

  const isThereImage = !!imageUrl;

  return (
    <div
      className={`dtv-html5-c-channel-lane-skeleton ${
        emptyChannelsMessage ? 'dtv-html5-c-channel-lane-skeleton--empty-message' : ''
      } ${
        withoutFilter ? 'dtv-html5-c-channel-lane-skeleton--without-filter' : ''
      } ${className}`}
    >
      {isThereImage ? (
        <img className="dtv-html5-c-channel-lane-skeleton__logo" src={imageUrl} alt={channel?.title || ''} />
      ) : (
        <Skeleton className="dtv-html5-c-channel-lane-skeleton__logo-skeleton" />
      )}
      <Skeleton className="dtv-html5-c-channel-lane-skeleton__schedule-card-container" />
      <Skeleton className="dtv-html5-c-channel-lane-skeleton__schedule-card-container" />
    </div>
  );
}

ChannelLaneSkeleton.propTypes = {
  className: PropTypes.string,
  channel: PropTypes.instanceOf(Channel),
  withoutFilter: PropTypes.bool,
  emptyChannelsMessage: PropTypes.bool,
};

ChannelLaneSkeleton.defaultProps = {
  className: '',
  channel: undefined,
  withoutFilter: false,
  emptyChannelsMessage: false,
};

export default memo(ChannelLaneSkeleton);
